import React from 'react';
import { ReactComponent as Legal } from './Legal.svg';

function LegalSvg() {
	return <Legal width="80pt" height="80pt" />;
}

export default LegalSvg;
